import { v4 as uuidv4 } from 'uuid';
import { createFileRoute } from '@tanstack/react-router'
import { analytics } from 'merchant-components'

const identify= async () => {
	// Check if an anonymous ID already exists
	let anonymousId = analytics.getUserId();

	// Identify the user with the anonymous ID
	analytics.identify(anonymousId, {
		anonymousId: anonymousId,
		isAnonymous: true,
	});
}

export const Route = createFileRoute('/(public)')({
	beforeLoad: identify
})
